import './Menu.css'
import '../css/glyhicon-spinner.css'

import { Glyphicon, MenuItem, Nav, NavDropdown, NavItem, Navbar } from 'react-bootstrap'

import BreadCrumbs from '../Breadcrumbs/BreadCrumbs.js'
import { Link } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import React from 'react'
import SpinningGlyhicon from '../SpinningGlyhicon.js'
import bufferImage from '../../images/buffer.jpg'
import find from 'lodash/find'
import logo from '../../images/exi_logo.png'
import macromoleculeImage from '../../images/macromolecule.png'
import myExperimentImage from '../../images/edit.png'
import shipmentImage from '../../images/shipping.png'
import shippingAddresseImage from '../../images/contacts.png'
import stockSolutionImage from '../../images/testtube.png'
import { withRouter } from 'react-router'

// css

/**
 * Menu class which is used to render the app main top menu
 */
class Menu extends React.Component {
  constructor(props) {
    super(props)
    this.onLogOutClicked = this.onLogOutClicked.bind(this)
  }

  onLogOutClicked() {
    this.props.history.push('/')
    this.props.doLogOut()
  }

  getLoggedOutRender() {
    return (
      <Navbar fluid inverse fixedTop>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">
              <img alt="" src={logo} style={{ width: 100, height: 50 }} />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
      </Navbar>
    )
  }

  getFetching(title, fetching, length) {
    return <SpinningGlyhicon fetching={fetching} title={title} length={length} />
  }

  getProposalMenuItem() {
    return (
      <LinkContainer to="/proposals">
        <NavItem eventKey={1} href="/proposals">
          {this.getFetching('Proposal', this.props.proposals.fetching, this.props.proposals.data.length)}
        </NavItem>
      </LinkContainer>
    )
  }

  getSessionsMenuItem() {
    return (
      <LinkContainer to="/sessions">
        <NavItem eventKey={2} href="/sessions">
          {this.props.sessions &&
            this.props.sessions.data &&
            this.getFetching('Sessions', this.props.sessions.fetching, this.props.sessions.data.length)}
        </NavItem>
      </LinkContainer>
    )
  }

  /** Get the MX menu */
  getMxMenuItem() {
    return (
      <NavDropdown eventKey="3" title="Mx" id="nav-dropdown-mx">
        <MenuItem header>Experiments</MenuItem>
        <LinkContainer to="/prepare/experiments">
          <MenuItem eventKey="3.1">
            <img alt="macromolecules" src={macromoleculeImage} /> Prepare experiment
          </MenuItem>
        </LinkContainer>
        <LinkContainer to="/prepare/myproteins">
          <MenuItem eventKey="3.2">
            <img alt="add shipment" src={stockSolutionImage} /> My proteins
          </MenuItem>
        </LinkContainer>
        <MenuItem divider />
        <MenuItem header>Shipments</MenuItem>
        <LinkContainer to="#">
          <MenuItem eventKey="3.3" onClick={() => this.props.showNewShipment(true)}>
            <img alt="add shipment" src={shipmentImage} /> Add shipment
          </MenuItem>
        </LinkContainer>
        <LinkContainer to="/prepare/mxshipments">
          <MenuItem eventKey="3.4"> List of shipments </MenuItem>
        </LinkContainer>
      </NavDropdown>
    )
  }

  /** Get the SAXS menu */
  getSaxsMenuItem() {
    return (
      <NavDropdown eventKey="4" title="Saxs" id="nav-dropdown-saxs">
        <MenuItem header>Prepare experiment</MenuItem>
        <LinkContainer to="/prepare/macromolecule">
          <MenuItem eventKey="4.1">
            <img alt="macromolecules" src={macromoleculeImage} /> Macromolecules
          </MenuItem>
        </LinkContainer>
        <LinkContainer to="/prepare/buffer">
          <MenuItem eventKey="4.2">
            <img alt="buffers" src={bufferImage} /> Buffers
          </MenuItem>
        </LinkContainer>
        <LinkContainer to="/prepare/myExperiments" disabled>
          <MenuItem eventKey="4.3">
            <img alt="myExperiments" src={myExperimentImage} /> My experiments
          </MenuItem>
        </LinkContainer>
        <MenuItem divider />
        <MenuItem header>Prepare shipment</MenuItem>
        <LinkContainer to="#" disabled>
          <NavItem eventKey="4.4">
            <img alt="stockSolutions" src={stockSolutionImage} /> Stock solutions
          </NavItem>
        </LinkContainer>
        <LinkContainer to="#" disabled>
          <NavItem eventKey="4.5">
            <img alt="shippingAddresses" src={shippingAddresseImage} /> Shipping addresses
          </NavItem>
        </LinkContainer>
        <LinkContainer to="#" disabled>
          <NavItem eventKey="4.6">
            <img alt="shipments" src={shipmentImage} /> Shipments
          </NavItem>
        </LinkContainer>
      </NavDropdown>
    )
  }

  getJobsMenuItem() {
    return (
      <LinkContainer to="/jobs">
        <NavItem eventKey={5} href="/jobs">
          {this.getFetching('Jobs', this.props.jobs.fetching, this.props.jobs.data.length)}
        </NavItem>
      </LinkContainer>
    )
  }

  getSelectedMenuItem() {
    let count = 0
    if (this.props.application.selectedDataCollectionGroups) {
      count = this.props.application.selectedDataCollectionGroups.length
    }

    if (this.props.application.selectedDataCollections) {
      count = count + this.props.application.selectedDataCollections.length
    }
    return (
      <LinkContainer to="/selected">
        <NavItem eventKey={6} href="/selected">
          {this.getFetching('Selection', false, count)}
        </NavItem>
      </LinkContainer>
    )
  }

  changeTheme(theme) {
    const link = find(document.getElementsByTagName('link'), function (o) {
      return o.href.indexOf('bootstrap.min.css') !== -1
    })
    if (link) {
      link.setAttribute('href', 'https://bootswatch.com/3/' + theme + '/bootstrap.min.css')
    }
  }

  render() {
    /** If there is not sessionId it means that we are not already been authenticated **/
    if (!this.props.user || !this.props.user.token) {
      return this.getLoggedOutRender()
    }

    return (
      <div>
        <Navbar collapseOnSelect fixedTop inverse>
          <Navbar.Header>
            <Navbar.Brand>
              <a style={{ fontSize: '16px' }} href="/">
                <img alt="" src={logo} className="logo" style={{ width: 75, height: 40 }} />
              </a>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav>
              {this.getProposalMenuItem()}
              {this.getSessionsMenuItem()}

              {this.getMxMenuItem()}
              {this.getSaxsMenuItem()}

              {this.props.configuration.dataAnalysis.enabled && this.getJobsMenuItem()}
              {this.props.configuration.dataAnalysis.enabled && this.getSelectedMenuItem()}
            </Nav>
            <Nav pullRight>
              <NavDropdown eventKey={7} title={<Glyphicon glyph="cog" />} id="nav-dropdown-settings">
                <NavDropdown title="Theme" id="nav-dropdown-theme">
                  {this.props.configuration.settings.themes.map((theme, index) => (
                    <MenuItem
                      key={index}
                      onClick={e => {
                        this.changeTheme(e.target.text)
                      }}
                    >
                      {theme}
                    </MenuItem>
                  ))}
                </NavDropdown>
              </NavDropdown>

              <NavItem eventKey={8} onClick={this.onLogOutClicked}>
                <Glyphicon glyph="glyphicon glyphicon-log-out" />
                Log out <strong>{this.props.user.username}</strong>
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <BreadCrumbs breadcrumbsList={this.props.breadcrumbsList} />
      </div>
    )
  }
}

const MenuWithRouter = withRouter(Menu)
export default MenuWithRouter
